import {FC} from 'react';
import {Button, Dialog, DialogActions, DialogTitle, Divider} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  useDeleteContractsCidDocumentId,
  useGetContractsCidDocumentsRefresh,
} from '../../../../global/services/contracts';
import {useParams} from 'react-router-dom';
import {toNumber} from 'lodash';
import {
  documentDeleteModalClose,
  useContractDocumentDeleteModalStore,
} from '../../stores/contract-document-delete-modal.store';
import {useRefreshCompanyTariff} from '../../../company-tariff';

export const DeleteDocumentConfirmModal: FC = () => {
  const {id: cid} = useParams();
  const deletableId = useContractDocumentDeleteModalStore((s) => s.deletableId);
  const {mutate, loading} = useDeleteContractsCidDocumentId();
  const refreshDocuments = useGetContractsCidDocumentsRefresh();
  const refreshCompanyTariff = useRefreshCompanyTariff();

  const afterMutationCallback = async () => {
    refreshDocuments();
    refreshCompanyTariff();
    documentDeleteModalClose();
  };

  const handleDelete = async () => {
    if (!cid || !deletableId) return;
    await mutate([toNumber(cid), deletableId], afterMutationCallback);
  };

  return (
    <Dialog fullWidth maxWidth="xs" open={!!deletableId}>
      <DialogTitle>Подтвердите удаление</DialogTitle>
      <Divider />
      <DialogActions>
        <Button variant="contained" onClick={documentDeleteModalClose} disabled={loading}>
          Отменить
        </Button>
        <LoadingButton color="error" variant="outlined" disabled={loading} onClick={handleDelete}>
          Удалить
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
